import { useChat } from '@terminal/views/alfred/research/use-chat/useChat';
import {
  MAX_FILES_PER_CONVERSATION,
  MAX_FILES_PER_QUESTION,
  useUserUpload,
} from '@terminal/views/alfred/research/use-user-upload/useUserUpload';

export const useUploadDisabled = (conversationId: string) => {
  const activeConversation = useChat(state =>
    state.getActiveConversation(conversationId)
  );

  const exceedMaxFilesPerConversation =
    (activeConversation?.tasks?.reduce(
      (sum, task) => sum + (task.attachments?.length ?? 0),
      0
    ) ?? 0) >= MAX_FILES_PER_CONVERSATION;

  const exceedMaxFilesPerQuestion = useUserUpload(
    state =>
      state.files.filter(f => f.status === 'complete').length >=
      MAX_FILES_PER_QUESTION
  );

  const disabled = exceedMaxFilesPerConversation || exceedMaxFilesPerQuestion;

  return {
    disabled,
  };
};
